module.exports = __webpack_public_path__ + "img/loans-compare.73ab617.webp";